import { render, staticRenderFns } from "./ctlItemImageHideFromRoles.vue?vue&type=template&id=aa8fc96a&"
import script from "./ctlItemImageHideFromRoles.vue?vue&type=script&lang=js&"
export * from "./ctlItemImageHideFromRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ctlItemImageHideFromRoles.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VAvatar,
  VChip,
  VIcon,
})
